(function() {
    'use strict';
    var BREAKPOINTS = {
        sm: 0,
        md: 640,
        lg: 1024
    };
    // ─── Instância do carrossel ───────────────────────────────────────
    function Carousel(el) {
        this.root = el;
        this.track = el.querySelector('.carousel-track');
        this.slides = Array.prototype.slice.call(el.querySelectorAll('.carousel-slide'));
        this.total = this.slides.length;
        if (this.total === 0) return;
        this.current = 0;
        this.autoplayEnabled = el.dataset.autoplay === 'true';
        this.interval = parseInt(el.dataset.interval, 10) || 5000;
        this.timer = null;
        this.paused = false;
        this.dragging = false;
        this.startX = 0;
        this.deltaX = 0;
        // Responsividade: slides visíveis por breakpoint
        this.breakpoints = {
            sm: parseInt(el.dataset.slidesSm, 10) || 1,
            md: parseInt(el.dataset.slidesMd, 10) || 1,
            lg: parseInt(el.dataset.slidesLg, 10) || 1
        };
        this.visible = this._calcVisible();
        this._bindEvents();
        this._applySlideSizing();
        this.goTo(0, true);
        if (this.autoplayEnabled) this._startAutoplay();
    }
    // ─── Navegação ────────────────────────────────────────────────────
    Carousel.prototype.goTo = function(index, instant) {
        var maxIndex = Math.max(0, this.total - this.visible);
        this.current = Math.max(0, Math.min(index, maxIndex));
        var offset = -(this.current * (100 / this.visible));
        this.track.style.transition = instant ? 'none' : 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        this.track.style.transform = 'translateX(' + offset + '%)';
        this._resetAutoplay();
    };
    Carousel.prototype.prev = function() {
        this.goTo(this.current - 1);
    };
    Carousel.prototype.next = function() {
        var maxIndex = Math.max(0, this.total - this.visible);
        // Loop: volta ao início se estiver no último
        this.goTo(this.current >= maxIndex ? 0 : this.current + 1);
    };
    // ─── Autoplay ─────────────────────────────────────────────────────
    Carousel.prototype._startAutoplay = function() {
        var self = this;
        this._stopAutoplay();
        this.timer = setInterval(function() {
            if (!self.paused) self.next();
        }, this.interval);
    };
    Carousel.prototype._stopAutoplay = function() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    };
    Carousel.prototype._resetAutoplay = function() {
        if (this.autoplayEnabled) this._startAutoplay();
    };
    // ─── Responsividade ───────────────────────────────────────────────
    Carousel.prototype._calcVisible = function() {
        var w = window.innerWidth;
        if (w >= BREAKPOINTS.lg) return this.breakpoints.lg;
        if (w >= BREAKPOINTS.md) return this.breakpoints.md;
        return this.breakpoints.sm;
    };
    Carousel.prototype._onResize = function() {
        var newVisible = this._calcVisible();
        if (newVisible !== this.visible) {
            this.visible = newVisible;
            this._applySlideSizing();
            this.goTo(this.current, true);
        }
    };
    Carousel.prototype._applySlideSizing = function() {
        var width = 100 / this.visible + '%';
        for(var i = 0; i < this.slides.length; i++){
            this.slides[i].style.minWidth = width;
            this.slides[i].style.maxWidth = width;
        }
    };
    // ─── Eventos ──────────────────────────────────────────────────────
    Carousel.prototype._bindEvents = function() {
        var self = this;
        // Botões prev/next
        var prevBtn = this.root.querySelector('.carousel-prev');
        var nextBtn = this.root.querySelector('.carousel-next');
        if (prevBtn) prevBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            self.prev();
        });
        if (nextBtn) nextBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            self.next();
        });
        // Pausar autoplay no hover
        this.root.addEventListener('mouseenter', function() {
            self.paused = true;
        });
        this.root.addEventListener('mouseleave', function() {
            self.paused = false;
        });
        // Pausar quando a aba fica invisível (Page Visibility API)
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) self.paused = true;
            else self.paused = false;
        });
        // Teclado: setas esquerda/direita quando focado
        this.root.setAttribute('tabindex', '0');
        this.root.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowLeft') {
                self.prev();
                e.preventDefault();
            }
            if (e.key === 'ArrowRight') {
                self.next();
                e.preventDefault();
            }
        });
        // Resize com debounce
        var resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                self._onResize();
            }, 150);
        });
        // Touch / drag
        this._bindTouch();
    };
    Carousel.prototype._bindTouch = function() {
        var self = this;
        var threshold = 50;
        function onStart(e) {
            self.dragging = true;
            self.startX = e.touches ? e.touches[0].clientX : e.clientX;
            self.deltaX = 0;
            self.track.style.transition = 'none';
        }
        function onMove(e) {
            if (!self.dragging) return;
            var x = e.touches ? e.touches[0].clientX : e.clientX;
            self.deltaX = x - self.startX;
            var offset = -(self.current * (100 / self.visible));
            var dragPercent = self.deltaX / self.root.offsetWidth * 100;
            self.track.style.transform = 'translateX(' + (offset + dragPercent) + '%)';
        }
        function onEnd() {
            if (!self.dragging) return;
            self.dragging = false;
            if (self.deltaX < -threshold) self.next();
            else if (self.deltaX > threshold) self.prev();
            else self.goTo(self.current) // snap de volta
            ;
        }
        this.track.addEventListener('touchstart', onStart, {
            passive: true
        });
        this.track.addEventListener('touchmove', onMove, {
            passive: true
        });
        this.track.addEventListener('touchend', onEnd);
        // Mouse drag
        this.track.addEventListener('mousedown', onStart);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onEnd);
    };
    // ─── Inicialização global ─────────────────────────────────────────
    function initAllCarousels() {
        var elements = document.querySelectorAll('.carousel');
        var instances = [];
        for(var i = 0; i < elements.length; i++)instances.push(new Carousel(elements[i]));
        return instances;
    }
    // Espera o DOM estar pronto — cobre todos os cenários de carregamento
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllCarousels);
    else // DOM já carregou (script defer, async, ou inserido dinamicamente)
    initAllCarousels();
    // Expõe para uso manual se necessário
    window.Carousel = Carousel;
    window.initAllCarousels = initAllCarousels;
})();

//# sourceMappingURL=index.518b9c76.js.map
